// Route-level loading state — the per-character pulse on "distilling
// your session" (kept from the original helm).

export function Loader() {
  return (
    <div className="loader mono" aria-label="Loading">
      {"distilling your session".split("").map((char, index) => (
        <span key={`${char}-${index}`}>{char}</span>
      ))}
    </div>
  );
}
